import { render } from "./PurchaseOrderList.vue?vue&type=template&id=56676a1e&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"

import "./PurchaseOrderList.vue?vue&type=style&index=0&id=56676a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56676a1e"]])

export default __exports__